export default {
  CallFlow: {
    data: []
  },
  updateJSON: {}
};
